module.exports = __webpack_public_path__ + "static/media/S (44).32a5274f.jpg";